var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import IntroPreview from '../../images/intro-video-preview.svg';
import StudentPreview from '../../images/student-video-preview.svg';
import ReportsPreview from '../../images/reports-video-preview.svg';
import { BlueButton } from '@hn-ui/buttons';
import { Play } from '@hn-ui/icons';
import { ContentContainer, ContentInfoContainer, ImageContainer, TextTitle, } from '../Common';
var PREVIEW_SETTINGS_BY_VIDEO = {
    intro: {
        width: 444,
        height: 259,
        image: _jsx(IntroPreview, { role: 'img', "aria-label": 'intro-preview' }, void 0),
    },
    reports: {
        width: 466,
        height: 262,
        image: _jsx(ReportsPreview, { role: 'img', "aria-label": 'reports-preview' }, void 0),
    },
    student: {
        width: 400,
        height: 234,
        image: _jsx(StudentPreview, { role: 'img', "aria-label": 'student-preview' }, void 0),
    },
};
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-gec03q" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  gap: 32px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  gap: 32px;\n"])));
var Inner = styled(ContentContainer).withConfig({ displayName: "Inner", componentId: "sc-1pt7c4h" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  gap: 56px;\n  ", "\n"], ["\n  gap: 56px;\n  ", "\n"])), function (_a) {
    var $reverse = _a.$reverse;
    return $reverse && 'flex-direction: row-reverse;';
});
var TextInfoContainer = styled(ContentInfoContainer).withConfig({ displayName: "TextInfoContainer", componentId: "sc-1523c1g" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  justify-content: space-between;\n"], ["\n  justify-content: space-between;\n"])));
var Title = styled(TextTitle).withConfig({ displayName: "Title", componentId: "sc-m64ft3" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: 0;\n  font-weight: 400;\n  text-align: center;\n"], ["\n  margin-bottom: 0;\n  font-weight: 400;\n  text-align: center;\n"])));
var PlayButton = styled(BlueButton).withConfig({ displayName: "PlayButton", componentId: "sc-zy1a7u" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: auto;\n\n  & > svg {\n    margin-right: 4px;\n\n    path:last-child {\n      fill: transparent;\n    }\n  }\n"], ["\n  margin-top: auto;\n\n  & > svg {\n    margin-right: 4px;\n\n    path:last-child {\n      fill: transparent;\n    }\n  }\n"])));
var TutorialSection = function (_a) {
    var title = _a.title, children = _a.children, video = _a.video, buttonLabel = _a.buttonLabel, onPlayVideo = _a.onPlayVideo, reverse = _a.reverse, rest = __rest(_a, ["title", "children", "video", "buttonLabel", "onPlayVideo", "reverse"]);
    var handlePlayVideo = function () {
        onPlayVideo(video);
    };
    var settings = PREVIEW_SETTINGS_BY_VIDEO[video];
    return (_jsxs(Container, __assign({}, rest, { children: [title && _jsx(Title, { children: title }, void 0), _jsxs(Inner, __assign({ "data-testid": 'tutorial-inner', "$reverse": reverse }, { children: [_jsxs(TextInfoContainer, { children: [children, buttonLabel && (_jsxs(PlayButton, __assign({ onClick: handlePlayVideo, fit: true }, { children: [_jsx(Play, { color: 'black100' }, void 0), buttonLabel] }), void 0))] }, void 0), _jsx(ImageContainer, __assign({ width: settings.width, height: settings.height, onClick: handlePlayVideo }, { children: settings.image }), void 0)] }), void 0)] }), void 0));
};
export { TutorialSection };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
